import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemResultLayoutComponentsProviderComponentBase } from '../../../../layouts/item-result/ItemResultLayoutComponentsProviderComponentBase';
import {
  ProductNotReturnableComponent,
  ProductVendorLinkComponent,
  ProductIdLabelComponent,
  ProductShortDescriptionComponent,
} from '../../../../../product';
import { ItemPriceComponent, ItemStockButtonComponent } from '../../../../common';
import { RenderInItemResultLayoutDirective } from '../../../../layouts';

@Component({
  selector: 'ideal-standard-item-result-layout-components-provider',
  imports: [
    RenderInItemResultLayoutDirective,
    ItemStockButtonComponent,
    ItemPriceComponent,
    ProductNotReturnableComponent,
    ProductVendorLinkComponent,
    ProductIdLabelComponent,
    ProductShortDescriptionComponent,
  ],
  standalone: true,
  templateUrl: './standard-item-result-layout-components-provider.component.html',
  styleUrl: './standard-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardItemResultLayoutComponentsProviderComponent extends ItemResultLayoutComponentsProviderComponentBase {}
